import { create } from "zustand";
import { devtools } from "zustand/middleware";
import StyledModal from "../planning/dialogs/newMaterialOrder/StyledModal";
import DeviceInformation from "./DeviceInformation";

type DeviceInfoIdType = "number" | "id";

type DeviceInfoStore = {
  value: number | string | null;
  idType: DeviceInfoIdType;
  show: (value: number | string, idType: DeviceInfoIdType) => void;
  close: () => void;
};

const useDeviceInfoStore = create<DeviceInfoStore>()(
  devtools(
    (set) => ({
      value: null,
      idType: "number",
      show: (value, idType) => set({ value, idType }),
      close: () => set({ value: null }),
    }),
    { name: "deviceinfo-storage" },
  ),
);

export const useDeviceInfoModal = () => {
  const show = useDeviceInfoStore((state) => state.show);

  return {
    showById: (id: number) => show(id, "id"),
    showByNumber: (number: string) => show(number, "number"),
  };
};

export default function DeviceInfoModal() {
  const value = useDeviceInfoStore((state) => state.value);
  const idType = useDeviceInfoStore((state) => state.idType);
  const close = useDeviceInfoStore((state) => state.close);

  return (
    <StyledModal open={value !== null} onShow={() => {}} onClose={close}>
      <DeviceInformation deviceId={String(value)} idType={idType} injectInfo={[]} withImage />
    </StyledModal>
  );
}
